import React from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const images = [
    require('./../../images/gallery/portrait/pic4.jpg'),
    require('./../../images/gallery/portrait/pic5.jpg'),
    require('./../../images/gallery/portrait/pic6.jpg'),
    require('./../../images/gallery/portrait/pic7.jpg'),
    require('./../../images/gallery/portrait/pic1.jpg'),
]

var bnr1 = require('./../../images/background/line.png');

class About4 extends React.Component {
    
    componentDidMount(){
        function loadScript(src) {
           
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      
    };
    
    render() {
        const options = {
            loop:true,
            autoplay:true,
            autoplayTimeout:3000,
            margin:30,
            nav:false,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            items:1,
            dots: true
        };
        return (
            <>
                <div className="section-full p-t80 p-b80 bg-white inner-page-padding">
                    <div className="container">
                        <div className="section-content ">
                            <div className="row">
                                <div className="col-lg-5 col-md-5 ">
                                    <div className="m-about ">
                                        <OwlCarousel className="owl-carousel about-us-carousel" {...options}>
                                            {images.map((item, index) => (
                                                <div className="item" key={index}>
                                                    <div className="ow-img">
                                                    <NavLink to="/about"><img src={item} alt=""/></NavLink>
                                                    </div>
                                                </div>
                                            ))}
                                        
                                        </OwlCarousel>
                                        
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-7">
                                    <div className="m-about-containt text-black p-t80">
                                        <div className="m-about-years bg-moving" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                                            <span className="text-primary large-title">25</span>
                                            <span className="large-title-info">Years of Experience</span>
                                        </div>
                                        <h3 className="font-weight-600">Delivering strategic, high-quality real estate and infrastructure development.</h3>
                                        <p>S. S. Raam Chendra is the visionary Chairman and Managing Director behind JVR &amp; JMR Group, leading two fast-growing organizations in infrastructure and real estate. With over 30 years of hands-on experience in land acquisition, large-scale development, and project delivery, he has overseen the strategic purchase of 1,500+ acres of clear-titled land and the organized development of more than 500 acres into high-quality communities.</p>
                                        <p>Known for combining strategic foresight with disciplined execution, Mr. Chendra builds teams and systems that consistently deliver projects on time, on budget, and to uncompromising quality standards. His leadership emphasizes long-term planning, strong governance, transparent processes, and a customer-first approach that strengthens trust with clients, partners, and stakeholders.</p>
                                        <p>A key competitive advantage under his stewardship is the Group’s ownership of in-house machinery and equipment, which accelerates execution, improves cost control, and ensures rigorous quality oversight. Under his guidance, the organizations have diversified across verticals, enhanced operational capabilities, and established a solid foundation for sustainable expansion.</p>
                                        <p>Mr. Chendra remains committed to acquiring selective, clear-titled land and delivering projects that combine innovation, operational excellence, and real value for investors and communities alike.</p>
                                        <div className="author-info p-t20">
                                            <div className="author-signature">
                                                <img src={require('./../../images/Signature+Black.png')} alt="Signature" width={150} />
                                            </div>
                                            <div className="author-name">
                                                <h4 className="m-t0">S. S. Raam Chendra</h4>
                                                <p>Chairman &amp; Managing Director</p>
                                            </div>
                                            <NavLink to="/contact" className="site-button btn-effect m-b15"><span>Get in touch</span></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default About4;